import type {StateCreator} from 'zustand'

export type MarkerCountsActions = {
  hydrateMarkerCounts: (counts: {unresolvedConversationCount?: number; annotationsCount?: number}) => void
  incrementUnresolvedConversationCount: () => void
  decrementUnresolvedConversationCount: () => void
}

export type MarkerCountsSlice = {
  /** Server-provided unresolved conversation count, kept in sync via mutations.
   *  Null before the marker counts request resolves. */
  unresolvedConversationCount: number | null
  /** Server-provided annotations count. Null before the marker counts request resolves. */
  annotationsCount: number | null
  markerCountsActions: MarkerCountsActions
}

export const createMarkerCountsSlice =
  (): StateCreator<MarkerCountsSlice, [['zustand/devtools', never]], [], MarkerCountsSlice> => (set, get) => ({
    unresolvedConversationCount: null,
    annotationsCount: null,
    markerCountsActions: {
      hydrateMarkerCounts: ({unresolvedConversationCount, annotationsCount}) => {
        set(
          {
            ...(unresolvedConversationCount !== undefined && {unresolvedConversationCount}),
            ...(annotationsCount !== undefined && {annotationsCount}),
          },
          undefined,
          'hydrateMarkerCounts',
        )
      },
      incrementUnresolvedConversationCount: () => {
        const current = get().unresolvedConversationCount
        if (current !== null) {
          set({unresolvedConversationCount: current + 1}, undefined, 'incrementUnresolvedConversationCount')
        }
      },
      decrementUnresolvedConversationCount: () => {
        const current = get().unresolvedConversationCount
        if (current !== null && current > 0) {
          set({unresolvedConversationCount: current - 1}, undefined, 'decrementUnresolvedConversationCount')
        }
      },
    },
  })
